import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { AccountType } from '../schema/AccountType';

/**
 * This function returns the account type of the user.
 * @returns
 */
export const getAccountType = (): AccountType =>
    isConsumer() ? AccountType.ConsumerAccount : AccountType.EnterpriseAccount;
